import type { AnyFormData, FormDataValue } from '../types/forms'

const BOOLEAN_FORM_FIELDS = ['receive_newsletter', 'terms_accepted']

export const serializeFormData = <T extends AnyFormData = AnyFormData>(
  form: HTMLFormElement
): T => {
  const formData = new FormData(form)
  const result: Record<string, FormDataValue> = {}

  for (const [key, value] of formData.entries()) {
    if (BOOLEAN_FORM_FIELDS.includes(key)) {
      result[key] = value === '1' || value === 'on'
    } else {
      if (typeof value === 'string') result[key] = value
    }
  }

  return result as T
}
